import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { ReactComponent as GearIcon } from 'images/v2/icons/svg/fill/svg/gear.svg';
import { EpdLinks } from 'routes/EpdRoutes';

interface Props {
  companyId?: string;
}

const OrganisationSettingsButton: React.FC<Props> = ({ companyId }) => {
  const history = useHistory();

  const handleClick = () => {
    if (!companyId) {
      return;
    }

    history.push(EpdLinks.manageCompany(companyId, 'settings'));
  };

  return (
    <Button type="button" onClick={handleClick}>
      <GearIcon />
      <span>Organisation settings</span>
    </Button>
  );
};

const Button = styled.button`
  width: 262px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0px 0px 0px 16px;
  border: none;
  border-radius: 4px;
  background: ${(props) => props.theme.colors.secondaryLightGreen30};
  color: ${(props) => props.theme.colors.primaryGreen};
  transition: background-color 0.2s;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.colors.elementsFilledInput};
  }

  svg {
    width: 16px;
    height: 16px;
  }

  span {
    font-family: 'Inter';
    font-weight: 400;
    font-size: 16px;
    color: ${(props) => props.theme.colors.primaryGreen};
    white-space: nowrap;
    margin-left: 16px;
  }
`;

export default OrganisationSettingsButton;
